import { render, staticRenderFns } from "./FeedFormulaList.vue?vue&type=template&id=54f292d6&scoped=true&"
import script from "./FeedFormulaList.vue?vue&type=script&lang=js&"
export * from "./FeedFormulaList.vue?vue&type=script&lang=js&"
import style0 from "./FeedFormulaList.vue?vue&type=style&index=0&id=54f292d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f292d6",
  null
  
)

export default component.exports